import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const authService = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => {
    return {
      authLogin: builder.mutation({
        query: (loginData) => {
          return {
            url: "api/login",
            method: "POST",
            body: loginData,
          };
        },
      }),
      userRegister: builder.mutation({
        query: (data) => {
          return {
            url: "api/register",
            method: "POST",
            // mode: "no-cors",
            body: data,
          };
        },
      }),
      forgetPassword: builder.mutation({
        query: (data) => {
          return {
            url: "api/forgetPassword",
            method: "POST",
            body: data,
          };
        },
      }),
      resetPassword: builder.mutation({
        query: (data) => {
          return {
            url: "api/resetPassword",
            method: "POST",
            body: data,
          };
        },
      }),
      userLogin: builder.mutation({
        query: (loginData) => {
          return {
            url: "api/login",
            method: "POST",
            mode: "no-cors",
            body: loginData,
          };
        },
      }),
    };
  },
});
export const {
  useAuthLoginMutation,
  useUserRegisterMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
  useUserLoginMutation,
} = authService;
export default authService;
